import { authErrorHandler } from '@/services/error/authHandler.js';

export default {
  fetchSiwfData({ commit }, payload) {
    try {
      const siwfData = getUserHandle(commit, payload).then(data => data);
      return siwfData;
    } catch (error) {
      console.error('Error fetching SIWF data from cookie:', error);
      authErrorHandler(error);
      return null;
    }
  },
};

async function getUserHandle(commit, payload) {
  const { fromUsername, toUsername } = payload || {};
  if (!fromUsername || !toUsername)
    return null;

  const usernameQuery = fromUsername && toUsername ? `?fromUsername=${encodeURIComponent(fromUsername)}&toUsername=${toUsername}` : '';
  const response = await fetch(`${import.meta.env.VITE_BACKEND_URI}/api/siwf/handle${usernameQuery}`, {
    method: 'GET',
    headers: {
      'content-type': 'application/json',
    },
    credentials: 'include',
  });

  if (!response) {
    const error = await response.json();
    throw new Error(error.message || 'failed to get user frequency handle.');
  }

  const siwfData = await response.json();
  commit('setSiwfData', siwfData);
  localStorage.setItem('userFrequencyHandle', siwfData?.userDetails?.frequencyHandle.baseHandle);

  return siwfData;
}
